<template lang="html">
  <div class="quotes">
    <blockquote class="blockquote">
      "A szorobán, szoroban (算盤, そろばん; Hepburn: soroban) egy Japánban kifejlesztett számolóeszköz.
      <br/>...<br/>
      Neuropszichológiai vélemények szerint a szorobán használata mindkét agyféltekét igénybe veszi. A fejben való szorobánozás fejleszti mind a képi emlékezetet, mind a szám- és szövegemlékezetet, valamit javítja a fejszámolás képességét. Ilyenkor egy elképzelt szorobánon számolnak, és csak utólag ellenőrzik az eredményeket. Segíti a finommozgásokat és a figyelmet, gondolkodásra szoktat. Könnyen szemléltethetők a helyi értékek, az átváltások, a maradékos és a közönséges osztás. Még az enyhe értelmi fogyatékos vagy diszkalkuliás gyerekeken is segít."
    </blockquote>
    <v-row justify="end">
      <v-col cols="6" sm="3">
        <a href="https://hu.wikipedia.org/wiki/Szorob%C3%A1n" target="_blank">Forrás: WIKIPÉDIA</a>
      </v-col>
    </v-row>

  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.quotes{
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;

  .blockquote{
    text-align: justify;
    padding-left: 0;
  }
  a{
    display: inline-block;
  }
}
</style>
